import { isReleasesSortBy, ReleasesSortBy } from 'ui-components';

export const RELEASES_SORT_STORAGE_KEY = 'as-releases-sort';

export function getReleasesSortFromLocalStorage(): ReleasesSortBy | undefined {
  try {
    const value = localStorage?.getItem(RELEASES_SORT_STORAGE_KEY);
    return isReleasesSortBy(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function saveReleasesSortPreference(sortBy: ReleasesSortBy): void {
  try {
    localStorage?.setItem(RELEASES_SORT_STORAGE_KEY, sortBy);
  } catch {
    // localStorage may be unavailable (private mode, blocked storage).
  }
}
